import React from "react";
import { SiteLineWordmark } from "../components/SiteLineWordmark";

/**
 * The same mark, at the same size and with the same glow, that the Identity
 * portal opens with. Carrying it across is what makes the handoff read as one
 * continuous pipeline.
 */
export function LaunchMark() {
  return <img className="launch__logo" src="/triaxis-logo-white.svg" alt="TriAxis Labs" />;
}

/** Same two assurances the Identity portal and the Portal dashboard both end on. */
export function LaunchFooter() {
  return (
    <div className="launch__footer">
      <span>End-to-end encrypted</span>
      <span className="launch__dot" />
      <span>DoD compliant</span>
    </div>
  );
}

/**
 * LaunchScreen — unified full-viewport launch state.
 *
 * Used across auth bridging and cold-start workspace hydration so the user
 * experiences one smooth, unbroken launch sequence without multiple disjoint
 * loading screens or layout jumps.
 */
export function LaunchScreen({
  title = "SiteLine",
  message = "Establishing secure session…",
}: {
  title?: string;
  message?: string;
}) {
  return (
    <div className="launch">
      <div className="launch__inner">
        <LaunchMark />
        <h1 className="launch__title">
          <SiteLineWordmark size="splash" alt={title} />
        </h1>
        <p className="launch__message">{message}</p>
        <div className="launch__progress" role="status" aria-label={message} />
        <LaunchFooter />
      </div>
    </div>
  );
}

export default LaunchScreen;
